module.exports = __webpack_public_path__ + "static/img/图层 526.8abffc08.png";